<template>
  <section class="page-interaction">
    <b-overlay
      :show="loading"
      no-center
      variant="transparent"
      rounded="sm"
    >
      <template #overlay>
        <loading-spinner />
      </template>
    </b-overlay>
  </section>
</template>

<script>
import {
  BOverlay, BRow, BTabs, BTab,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import { throwDefaultError } from '@/helpers/helpers'
// eslint-disable-next-line import/extensions

// import { getUser } from '@/auth/utils'

export default {
  name: 'GiftsIndex',
  components: {
    BOverlay,
    BRow,
    BTabs,
    BTab,
  },
  data() {
    return {
      loading: false,
    }
  },
  created() {
    this.bohoClubListTypes()
    this.bohoClubPublishers()
  },
  methods: {
    bohoClubListTypes() {
      this.loading = true
      useJwt.bohoClubListTypes()
        .then(response => {
          console.log('response', response)
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => { this.loading = false })
    },
    bohoClubPublishers() {
      this.loading = true
      useJwt.bohoClubPublishers()
        .then(response => {
          console.log('response', response)
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => { this.loading = false })
    },
    setLoading($event) {
      this.loading = $event
    },
  },
}
</script>
